import { ref } from 'vue';

// Module-level for the same reason as the chat panel's: the notifications panel
// is opened from outside the navbar too — from the burger menu, which is where
// the bell goes once the header is too narrow to carry it. The side effects of
// opening (closing the chat panel, marking notifications seen) stay in
// user-menu-icons.vue, which watches this ref.
//
// Note for anyone importing this: in <script setup> a string template ref
// resolves against the setup bindings, so `ref="notificationsPanel"` on the
// panel component and an import of the same name are the same binding. Vue then
// tries to write the instance into the readonly import and throws on every
// patch — which silently aborts the rest of that patch, taking the header's
// poppers down with it. The template ref is `notificationsPanelRef`.
const isOpen = ref(false);

export const notificationsPanel = {
  isOpen,
  toggle: () => {
    isOpen.value = !isOpen.value;
  },
};
